import { render, staticRenderFns } from "./DeliveryTraceList.vue?vue&type=template&id=88c7bf42"
import script from "./DeliveryTraceList.vue?vue&type=script&lang=js"
export * from "./DeliveryTraceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports